import React from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {useDispatch} from 'react-redux'

import {connect} from 'react-redux'
import {showAlert} from '../../actions'

import AccountArtistForm from '../user/AccountArtistForm'
import AccountVenueForm from '../user/AccountVenueForm'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'



const styles = {
  skipContainer: css`
    display: flex;
    align-items: flex-end;
    flex-flow: column;
    margin-top: 35px;

    p {
      text-align: right;
      max-width: 200px;
      color: #818181;
    }
  `,
  skip: css`
    cursor: pointer;
    display: flex;
    gap: 5px;
    font-weight: 500;
    color: #434343;
    margin-bottom: 5px;

    p {
      color: #434343;
    }
  `
}



const AccountRegistrationForm = props => {

  const dispatch = useDispatch()

  const {type, showAlert} = props



  function callback() {
    dispatch({type: 'AUTH_STATUS_SUCCESS'})
    showAlert('Welcome to Ckord!', 'success')
  }



  return (
    <div>
      {type === 'venue'  && <AccountVenueForm  callback={callback} />}
      {type === 'artist' && <AccountArtistForm callback={callback} />}

      <div css={styles.skipContainer}>
        <div css={styles.skip} onClick={callback}>
          <p>Skip Step</p>

          <ArrowForwardIcon fontSize='small' /> 
        </div>

        <p>
          You can skip this step and register as an artist or venue later.
        </p>
      </div>
    </div>
  )
}




export default connect(null, {showAlert})(AccountRegistrationForm)


